var React = require('react');

function DogSit (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0.000000,60.000000) scale(0.100000,-0.100000)","fill":"#E5E7EB","stroke":"none"},React.createElement("path",{"d":"M383 525 c-39 -17 -74 -78 -55 -97 18 -18 -3 -44 -78 -93 -82 -55\n-110 -102 -110 -185 0 -52 0 -53 -19 -36 -11 10 -21 28 -23 40 -2 11 -10 21\n-18 21 -23 0 -16 -63 9 -89 19 -19 35 -21 147 -24 102 -3 125 -1 122 10 -3 7\n-17 19 -31 26 -32 16 -34 28 -6 42 11 7 27 26 34 43 l13 32 7 -25 c3 -14 5\n-34 4 -45 -2 -11 4 -35 11 -52 12 -28 20 -33 47 -33 38 0 53 18 29 35 -20 15\n-48 147 -35 167 5 7 9 37 9 66 0 66 13 92 45 92 17 0 29 9 40 30 21 41 19 47\n-14 55 -16 3 -35 13 -42 21 -14 18 -44 17 -86 -1z"})));
}

DogSit.defaultProps = {"version":"1.0","width":"60.000000pt","height":"60.000000pt","viewBox":"0 0 60.000000 60.000000","preserveAspectRatio":"xMidYMid meet"};

module.exports = DogSit;

DogSit.default = DogSit;
